module.exports = __webpack_public_path__ + "img/barraTitulo.f6614984.svg";